import React from 'react';
import { motion } from 'framer-motion';
export function WhyMattersSection() {
  return <section className="py-32 bg-brand-black text-white relative overflow-hidden" data-id="element-177">
      {/* Subtle grid background */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff0a_1px,transparent_1px),linear-gradient(to_bottom,#ffffff0a_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" data-id="element-178"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-179">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold mb-16 leading-tight" data-id="element-180">
          Ownership Should Be{' '}
          <span className="text-brand-tealLight italic" data-id="element-181">Accessible.</span>
        </motion.h2>

        <div className="space-y-12 text-xl md:text-2xl lg:text-3xl font-light leading-relaxed text-gray-300" data-id="element-182">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-183">
            Thousands of Canadian business owners are preparing to exit.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-184">
            Yet too many diverse entrepreneurs remain{' '}
            <span className="text-white font-medium" data-id="element-185">excluded</span> from
            acquisition opportunities.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-186">
            Traditional succession models often preserve access for the few.{' '}
            <br data-id="element-187" />
            <span className="text-brand-tealLight font-medium" data-id="element-188">
              This study challenges that model.
            </span>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="pt-12 mt-12 border-t border-white/10" data-id="element-189">
            <p className="font-serif text-3xl md:text-4xl text-white italic" data-id="element-190">
              This is not just succession.
              <br data-id="element-191" />
              This is economic transformation.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}